import { Alert, AlertTitle } from '@mui/material'
import { parseFormLabelText } from 'app/views/forms/common/Common'

const addNewLines = (text) => {
  return text.replace(/\n/g, '<br/>')
}

export const FormBanner = ({
  title,
  typeProps,
  ...props
}) => {
  const { text } = typeProps

  const variant = typeProps?.variant || 'standard'
  const state = typeProps?.state || 'info'

  const parsedText = parseFormLabelText({ text, ...props })

  const marginTopContent = title ? 8 : 4

  return (
    <div style={{ padding: 12 }}>
      <Alert variant={variant} severity={state}>
        <div style={{ marginTop: marginTopContent }}>
          <AlertTitle>{title}</AlertTitle>
          <div
            dangerouslySetInnerHTML={{
              __html: addNewLines(parsedText)
            }}
          />
        </div>
      </Alert>
    </div>
  )
}
